import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EcapLoginService, UserInfoService } from '@ecap3/core';
import { FuseNavigationItem, FuseNavigationService } from '@ecap3/template-atlas';

@Component({
    selector   : 'fuse-nav-vertical-item',
    templateUrl: './item.component.html',
    styleUrls  : ['./item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit, OnDestroy
{
    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: FuseNavigationItem;

    // Private
    private _unsubscribeAll: Subject<any>;

    currentUserId: any;

    /**
     * Constructor
     */

    /**
     *
     * param {ChangeDetectorRef} _changeDetectorRef
     * param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private readonly loginService: EcapLoginService,
        private readonly userInfo: UserInfoService
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to navigation item
        merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: () => {
                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                }
            });
        this.userInfo.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (result: any) => {
                    if (result.IsSuccess && result.UserId) {
                        this.currentUserId = result.UserId;
                    }
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    logout() {
        console.log("Logging out");
        const message = JSON.stringify({
            action: 'userInfo',
            data: {
                action: 'userLogout',
                userId: this.currentUserId
            }
        });
        if ((window as any).FlutterBridge) {
            console.log("[userLogout] FlutterBridge detected.");
            (window as any).FlutterBridge.postMessage(message);
        }
        this.loginService.logoutFromPlatform();
    }

    // logout(): void
    // {
    //     this.loginService.logoutFromPlatform();
    // }
}
